<style scoped>
.checkin {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px 20px;
  box-sizing: border-box;
  background: #f4f7fc;
}
.checkin_title {
  font-size: 14px;
  color: #5c5c5c;
  margin-bottom: 10px;
}
.checkin_information {
  width: 100%;
  overflow-y: scroll;
  display: flex;
  flex: 1;
  flex-direction: column;
  box-sizing: border-box;
}
.checkin_information::-webkit-scrollbar {
  display: none;
}
.checkin_information_top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.checkin_information_btoom {
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: space-between;
}
</style>

<template>
  <div class="checkin">
    <div class="checkin_title">数据看板</div>
    <div class="checkin_information">
      <div class="checkin_information_top">
        <information-card title="在职员工(人)" :value="employedUser" :icon="Icon1"></information-card>
        <information-card title="离职员工(人)" :value="leaveUser" :icon="Icon2"></information-card>
        <information-card title="在线设备(台)" :value="onlineDevice" :icon="Icon3"></information-card>
        <information-card title="离线设备(台)" :value="offlineDevice" :icon="Icon4"></information-card>
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="考勤" name="attendance"></el-tab-pane>
        <el-tab-pane label="门禁" name="control"></el-tab-pane>
      </el-tabs>

      <attendance-pane v-if="activeName === 'attendance'"/>
      <access-control-pane v-if="activeName === 'control'"/>
    </div>
    <company-footer-info />
  </div>
</template>


<script>
import Icon1 from "@/assets/bulletin/icon1.png";
import Icon2 from "@/assets/bulletin/icon2.png";
import Icon3 from "@/assets/bulletin/icon3.png";
import Icon4 from "@/assets/bulletin/icon4.png";
import InformationCard from "@/components/InformationCard.vue";
import CompanyFooterInfo from "@/components/companyFooterInfo.vue";
import AttendancePane from "@/views/dashboard/AttendancePane.vue";
import AccessControlPane from "@/views/dashboard/AccessControlPane.vue";
import {DmsDeviceApi} from "@/api/server/dmsDevice";
import {countUser} from "@/api/server/umsUser";

export default {
  components: {
    CompanyFooterInfo,
    InformationCard,
    AttendancePane,
    AccessControlPane
  },
  data() {
    return {
      Icon1: Icon1,
      Icon2: Icon2,
      Icon3: Icon3,
      Icon4: Icon4,
      activeName: 'attendance',

      //人员统计
      employedUser: 0,
      leaveUser: 0,
      applyUser: 0,
      //设备统计
      onlineDevice: 0,
      offlineDevice: 0,
      dashboardHeaderInterval: null
    };
  },
  created() {

  },
  mounted() {
    this.init();
    this.dashboardHeaderInterval = setInterval(() => {
      this.init();
    },30000)
  },
  destroyed() {
    this.dashboardHeaderInterval && clearInterval(this.dashboardHeaderInterval);
    this.dashboardHeaderInterval = null;
  },
  methods: {
    init(){
      this.getUserNum();
      this.getDeviceNum();
    },
    //统计用户
    async getUserNum() {
      let { data  } = await countUser();
      this.employedUser = data?.employedCount || 0;
      this.leaveUser = data?.leaveCount || 0;
      this.applyUser = data?.applyCount || 0;
    },
    //统计设备
    async getDeviceNum() {
      let {  data  } = await DmsDeviceApi.countDevice()
      this.onlineDevice = data?.onlineCount || 0;
      this.offlineDevice = data?.offlineCount || 0;
    },

  },

};
</script>